export const dateTimeFormat = {
    "timeFormats": "MM/dd/yyyy hh:mm:ss a",
    "dateFormats":  "MM/dd/yyyy"
}

export const dateTimeFormatParameters = {
    "TIME_FORMATS": "timeFormats",
    "DATE_FORMATS": "dateFormats"
}
